import { render } from "./formgroupswitch.vue?vue&type=template&id=9d629556"
import script from "./formgroupswitch.vue?vue&type=script&lang=js"
export * from "./formgroupswitch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__